/* eslint-disable import/no-unresolved, react/prop-types, no-prototype-builtins */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { line } from 'd3-shape'
import * as d3Color from 'd3-color'

import find from 'lodash/find'
import groupBy from 'lodash/groupBy'

import zones, { zonesReversed } from '../../Utilities/ZoneSizing'
import RunCalculations from '../../Utilities/RunCalculations'

import ColorPalette from '../../Utilities/Colors/Palettes'
import setTextColorWithBackground from '../../Utilities/Colors/TextColorBasedOnBackground'

// import ZoneLegend from "../Legend/ZoneLegend";

const zoneValues = [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '11',
    '12',
    '13',
    '14',
]

const nullValues = [null, undefined, '']

function getFill(chartType, calculations, colorFn) {
    const stat = calculations[chartType]
    const nullishColor = 'rgb(237, 237, 237)'

    if (nullValues.includes(stat)) {
        return nullishColor
    }

    const color = colorFn(Number(stat))

    return calculations?.totalPitches ? color : nullishColor
}

export default function Zone({ settings, chartOptions = {} }) {
    const chartType = chartOptions.type
    const pitcherView = chartOptions.pitcherPerspective

    let pitchData = settings.data

    // Use this option if you want to directly send in pre-processed zones
    if (!chartOptions.skipDataProcess) {
        pitchData = groupBy(settings.data, 'zone')
    }

    const counts = []
    for (let i = 0; i < zoneValues.length; i++) {
        const zone = zoneValues[i]
        if (pitchData.hasOwnProperty(zone)) {
            counts.push({
                zone: `zone_${zone}`,
                calculations: RunCalculations(
                    pitchData[zone],
                    settings.data.length
                ),
            })
        } else {
            counts.push({
                zone: `zone_${zone}`,
                calculations: RunCalculations([], settings.data.length),
            })
        }
    }

    const palette = new ColorPalette({
        type: chartType,
        data: counts,
    })
    const { color } = palette

    const x = scaleLinear().range([0, settings.vizWidth]).domain([-4, 4])

    const y = scaleLinear().range([settings.vizHeight, 0]).domain([-4, 4])

    const draw = line()
        .x((d) => x(d.x))
        .y((d) => y(d.y))

    const zonePaths = []

    const getValue = (zoneNum) => {
        const zone = find(counts, (d) => d.zone === zoneNum)
        if (zone?.calculations?.totalPitches) {
            try {
                const stat = zone.calculations[chartType]
                if (nullValues.includes(stat)) {
                    return '—'
                }
                return stat
            } catch {
                return '—'
            }
        } else {
            return '—'
        }
    }

    const zonesView = pitcherView ? zonesReversed : zones

    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const zone in zonesView) {
        const id = Number(zone.split('_')[1])

        let dx = 0
        if (id < 10) {
            dx = x(1 / 3) - x(0)
        } else if (pitcherView && (id === 11 || id === 13)) {
            dx = -8
        } else if (!pitcherView && (id === 12 || id === 14)) {
            dx = -8
        } else if (pitcherView && (id === 12 || id === 14)) {
            dx = 8
        } else if (!pitcherView && (id === 11 || id === 13)) {
            dx = 8
        }

        let dy
        if (id < 10) {
            dy = y(0) - y(1 / 3)
        } else if (id === 11 || id === 12) {
            dy = 8
        } else {
            dy = -8
        }

        const count = find(counts, (d) => d.zone === zone)
        const classes = [
            `zone-text-${id > 10 ? 'outer' : 'inner'}`,
            `zone-text-${id}`,
            `zone-text-perspective-${pitcherView ? 'pitcher' : 'catcher'}`,
        ]

        const fill = getFill(chartType, count?.calculations, color)

        zonePaths.push(
            <g key={`zone_${zone}`}>
                <path
                    id={zone}
                    d={draw(zonesView[zone])}
                    fill={fill}
                    className="evp-zone"
                    opacity={chartOptions.opacity}
                />
                {chartOptions.showText ? (
                    <text
                        className={classes.join(' ')}
                        x={x(zonesView[zone][0].x)}
                        y={y(zonesView[zone][0].y)}
                        fill={
                            count?.calculations?.totalPitches
                                ? setTextColorWithBackground(
                                      d3Color.color(fill)
                                  )
                                : '#666'
                        }
                        dx={dx}
                        dy={dy}
                    >
                        {getValue(zone)}
                    </text>
                ) : null}
            </g>
        )
    }

    return (
        <>
            <g id="zones">{zonePaths}</g>
            {/* <ZoneLegend
        settings={settings}
        range={[0, maxCount / 4, maxCount / 2, maxCount / 1.4, maxCount]}
        color={color}
      /> */}
        </>
    )
}
